<app-modal
  #modal
  [modalConfig]="{
    titleText: 'Bulk Registration',
    headerClass: ['modal-header', 'bg-primary', 'text-white'],
    showFooter: false,
    closeOnBgClick: false,

  }"
  (isDismissing)="resetForm()"
  (isClosing)="resetForm()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <form #emailForm="ngForm" class="mb-3">
    <div class="form-row">
      <label for="recipients" class="form-label w-100">Recipients</label>
      <textarea
        aria-label="Recipients"
        placeholder="Enter email addresses separated by commas (,) or line breaks"
        #recipients="ngModel"
        name="recipients"
        class="form-control"
        .
        re
        rows="5"
        [(ngModel)]="emailRecipients"
        [ngClass]="{
          'is-invalid': recipients.invalid && recipients.touched
        }"
        required></textarea>
    </div>
  </form>
  <ng-container *ngIf="bulkResponse">
    <div class="text-center fw-500 fs-19 my-5">
      <ng-container *ngIf="bulkResponse.attendees.length > 0">
        <i class="bi bi-check-circle me-2 color-success"></i
      ></ng-container>
      <ng-container
        *ngIf="bulkResponse.totalEmailsProvided === 1; else mutiple">
        <ng-container *ngIf="bulkResponse.attendees.length > 0">
          Attendee added.
        </ng-container>
      </ng-container>
      <ng-template #mutiple>
        {{ bulkResponse.attendees.length }} of
        {{ bulkResponse.totalEmailsProvided }} attendees registered.
      </ng-template>
    </div>
    <ng-container
      *ngIf="
        (bulkResponse.notFound && bulkResponse.notFound.length > 0) ||
        (bulkResponse.existing && bulkResponse.existing.length > 0) ||
        (bulkResponse.facilitator && bulkResponse.facilitator.length > 0)
      ">
      <div class="alert alert-danger text-start mt-4 mb-3" role="alert">
        The following errors have occured:
      </div>
      <ul class="error-users fs-14 ms-3 pb-5">
        <ng-container *ngFor="let email of bulkResponse.facilitator">
          <li>
            User <span class="text-danger">{{ email }}</span> is a facilitator
            for this event.
          </li>
        </ng-container>
        <ng-container *ngFor="let email of bulkResponse.existing">
          <li>
            User <span class="text-danger">{{ email }}</span> is already
            registered.
          </li>
        </ng-container>
        <ng-container *ngFor="let email of bulkResponse.notFound">
          <li>
            User <span class="text-danger">{{ email }}</span> does not exist.
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="errorMessage">
    <div class="alert alert-danger text-start my-4 text-break" role="alert">
      {{ errorMessage }}
    </div>
  </ng-container>

  <div class="custom-footer">
    <div class="d-flex justify-content-between">
      <button type="button" class="btn" (click)="closeModal()">Cancel</button>
      <button
        [disabled]="!emailRecipients || isLoading"
        type="button"
        class="btn btn-md btn-primary"
        (click)="submitForm()">
        <ng-container *ngIf="isLoading">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </ng-container>
        Add Attendees
      </button>
    </div>
  </div>
</app-modal>
